<template>
  <div>
    <el-form
      v-if="showPage"
      class="setp-form"
      ref="step1form"
      :rules="rules"
      :model="form"
      label-width="155px"
      size="small"
    >
      <el-form-item label="培训主题" prop="actTitle">
        <el-input
          v-model="form.actTitle"
          style="width: 400px"
          maxlength="20"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="年级" prop="grades">
        <el-select
          v-model="form.grades"
          placeholder="请选择"
          clearable
          multiple
          value-key="grade"
        >
          <el-option
            v-for="item in gradeOptions"
            :key="item.id"
            :label="item.gradeName"
            :value="{ grade: item.grade, gradeName: item.gradeName }"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学科" prop="disciplineCodeList">
        <el-checkbox-group v-model="form.disciplineCodeList">
          <el-checkbox
            v-for="i in disciplineOptions"
            :key="i.id"
            :label="i.disciplineCode"
            >{{ i.disciplineName }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="培训类型" prop="validatorActive">
        <dic-code-selector
          dicType="trainLevel"
          v-model="form.classify3"
        ></dic-code-selector>
      </el-form-item>
      <el-form-item label="培训时间" prop="allDate">
        <el-date-picker
          v-model="form.allDate"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="培训地点" prop="allAddress">
        <el-select
          style="width: 200px; margin-right: 10px"
          v-model="form.orgCode"
          placeholder="请选择"
        >
          <el-option
            v-for="item in orgOptions"
            :key="item.orgCode"
            :label="item.orgName"
            :value="item.orgCode"
          ></el-option>
        </el-select>
        <el-select
          style="width: 200px; margin-right: 10px"
          v-model="form.schoolCode"
          placeholder="请选择"
        >
          <el-option
            v-for="(i, index) in schoolList"
            :key="index"
            :label="i.schoolName"
            :value="i.schoolCode"
          ></el-option>
        </el-select>
        <el-input
          v-model="form.address"
          style="width: 200px"
          maxlength="9"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="活动环节附件是否可见" prop="isAttachVisible">
        <el-radio-group v-model="form.isAttachVisible">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="活动成果附件是否可见" prop="isAttachOpen">
        <el-radio-group v-model="form.isAttachOpen">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="参与教师" prop="joinUser">
        <!-- <el-checkbox-group key="1" v-model="form.joinSchoolCode">
          <el-checkbox
            v-for="(i, index) in schoolList"
            :key="index"
            :label="i.schoolCode"
            >{{ i.schoolName }}所有教师</el-checkbox
          >
        </el-checkbox-group> -->
        <el-checkbox-group key="2" v-model="form.groupCode">
          <el-checkbox
            v-for="i in groupOptions"
            :key="i.id"
            :label="i.groupCode"
            >{{ i.groupName }}</el-checkbox
          >
        </el-checkbox-group>
        <span>
          指定教师
          <el-button type="text" @click="addOtherUser">添加</el-button>
          <el-button type="text" @click="cancelOtherUser">取消</el-button>
        </span>
        <div class="scorll-list" v-if="form.joinUsers.length > 0">
          <el-tag
            @close="tagJoinRemove(tag.userId)"
            size="small"
            v-for="tag in form.joinUsers"
            :key="tag.id"
            closable
            >{{ tag.userName }}</el-tag
          >
        </div>
        <join-pop
          @close="closeJoinPop"
          @joinUsersChange="joinUserChange"
          :showJoinPop="showJoinPop"
          v-if="showJoinPop"
        ></join-pop>
      </el-form-item>
      <el-form-item label="主持人">
        <el-input
          v-if="form.actCode"
          v-model="form.createName"
          style="width: 400px"
          disabled
        ></el-input>
        <el-input
          v-else
          v-model="userInfo.userName"
          style="width: 400px"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="主讲人" prop="speakUser">
        <el-button type="text" @click="addSpeakUser">添加本校教师</el-button>
        <br />
        <el-button type="text">添加非本校教师</el-button>
        <el-select
          class="other-select"
          @change="changeKnowledge"
          v-model="form.otherSchoolUsers"
          clearable
          remote
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="非本校教师请输入姓名"
        ></el-select>
        <div class="scorll-list" v-if="form.speakUsers.length > 0">
          <el-tag
            @close="tagSpeakRemove(tag.userId)"
            size="small"
            v-for="tag in form.speakUsers"
            :key="tag.id"
            closable
            >{{ tag.userName }}</el-tag
          >
        </div>
        <join-pop
          @close="closeSpeakPop"
          @joinUsersChange="speakUserChange"
          :showJoinPop="showSpeakPop"
          v-if="showSpeakPop"
        ></join-pop>
      </el-form-item>
      <el-form-item label="培训目标或内容" prop="actContent">
        <el-input
          v-model="form.actContent"
          style="width: 600px"
          type="textarea"
          maxlength="200"
          show-word-limit
          :autosize="{ minRows: 5, maxRows: 8 }"
          placeholder="请输入培训目标或内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="培训安排" prop="actPlan">
        <el-input
          v-model="form.actPlan"
          style="width: 600px"
          type="textarea"
          maxlength="200"
          show-word-limit
          :autosize="{ minRows: 5, maxRows: 8 }"
          placeholder="请输入培训安排"
        ></el-input>
      </el-form-item>
      <el-form-item label="培训封面" prop="faceAttaches">
        <face v-model="form.faceAttaches"></face>
      </el-form-item>

      <div style="display: flex; justify-content: center">
        <el-button
          :loading="btnLoading"
          size="small"
          @click="submitForm(false)"
          type="primary"
          >下一步 填写培训环节</el-button
        >
        <el-button type="primary" size="small" @click="submitForm(true)"
          >立即发布</el-button
        >
      </div>
    </el-form>
    <div v-loading="!showPage"></div>
  </div>
</template>
<script>
import { postData, getData, postJson } from '@/http/fetch.js'
import JoinPop from '@/components/common/JoinPop.vue'
import { mapState, mapGetters } from 'vuex'
import Face from '@/components/common/Face.vue'
import DicCodeSelector from '@/components/common/DicCodeSelector.vue'
export default {
  components: {
    Face,
    JoinPop,
    DicCodeSelector
  },
  computed: {
    ...mapState(['userInfo', 'schoolList', 'isAdmin']),
    ...mapGetters(['schoolCodes']),
    orgOptions: function () {
      let orgList = [
        {
          orgCode:
            this.userInfo.teacherSchoolList[0].orgCode ||
            this.userInfo.teacherSchoolList[0].schoolCode,
          orgName:
            this.userInfo.teacherSchoolList[0].orgName ||
            this.userInfo.teacherSchoolList[0].schoolName
        }
      ]
      return orgList
    }
  },
  data() {
    var validatorActiveType = (rule, value, callback) => {
      if (this.form.classify3 === '') {
        return callback(new Error('请选择培训类型'))
      } else {
        callback()
      }
    }
    var validatorJoinUser = (rule, value, callback) => {
      if (
        this.form.joinUsers.length === 0 &&
        this.form.joinSchoolCode.length === 0 &&
        this.form.groupCode === 0
      ) {
        return callback(new Error('请选择参与教师'))
      } else {
        callback()
      }
    }
    var validatorSpeakUser = (rule, value, callback) => {
      if (
        (this.form.speakUsers.length === 0) &
        (this.form.otherSchoolUsers.length === 0)
      ) {
        return callback(new Error('请选择主讲人'))
      } else {
        callback()
      }
    }
    var validatorAllAddress = (rule, value, callback) => {
      if (
        this.form.orgCode == '' ||
        this.form.schoolCode == '' ||
        this.form.address == ''
      ) {
        return callback(new Error('请完善培训地点'))
      } else {
        callback()
      }
    }
    return {
      showPage: false,
      btnLoading: false,
      showJoinPop: false, //指定老师弹框
      showSpeakPop: false, //主讲老师弹框
      gradeOptions: [],
      disciplineOptions: [],
      groupOptions: [],
      form: {
        actType: 'training', //，培训：training，项目课题：topic，教育工作：education
        actTitle: '', //培训主题
        grades: '',
        disciplineCodeList: [],
        disciplineCode: [],
        classify3: '',
        // classify2: "",
        allDate: [], //startDate:"",endDate:"",
        startDate: '',
        endDate: '',
        joinSchoolCode: [],
        joinUsers: [],
        groupCode: [],
        operatorId: '',
        speakUsers: [], //主讲人
        otherSchoolUsers: [],
        actPlan: '', //安排
        actContent: '', //目标
        faceAttaches: [], //封面

        orgCode: '', //集团代码
        schoolCode: '', //校区代码
        address: '',
        isAttachVisible: 1,
        isAttachOpen: 1
      },
      rules: {
        actTitle: [
          { required: true, message: '请输入培训主题', trigger: 'blur' }
        ],
        // grades: [{ required: true, message: "请选择年级", trigger: "blur" }],
        // disciplineCodeList: [
        // 	{ required: true, message: "请选择学科", trigger: "change" }
        // ],
        // validatorActive: [
        //   { validator: validatorActiveType, required: true, trigger: "blur" }
        // ],
        joinUser: [
          { validator: validatorJoinUser, required: true, trigger: 'blur' }
        ],
        speakUser: [
          { validator: validatorSpeakUser, required: true, trigger: 'blur' }
        ],
        allAddress: [
          { validator: validatorAllAddress, required: true, trigger: 'change' }
        ],
        allDate: [
          { required: true, message: '请选择培训时间', trigger: 'change' }
        ],
        // actContent: [
        // 	{ required: true, message: "请输入培训目标或内容", trigger: "blur" }
        // ],
        // actPlan: [
        // 	{ required: true, message: "请输入培训安排", trigger: "blur" }
        // ],
        faceAttaches: [
          { required: true, message: '选择培训封面', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.showPage = false
      await this.getGradeList()
      await this.getDiscipline()
      await this.groupList()
      //回显
      if (sessionStorage.getItem('actCode')) {
        let activeInfo = await getData('/training/getActiveInfo', {
          actCode: sessionStorage.getItem('actCode'),
          operatorId: this.userInfo.userId
        })
        this.form = { ...activeInfo }
        //封面从资源删除后会没有次字段  导致效验不通过
        if (!activeInfo.faceAttaches) {
          this.$set(this.form, 'faceAttaches', [])
        }
        if (!activeInfo.groupCode) {
          this.$set(this.form, 'groupCode', [])
        } else {
          this.$set(this.form, 'groupCode', JSON.parse(activeInfo.groupCode))
        }
        this.$set(
          this.form,
          'disciplineCodeList',
          activeInfo.disciplines.map((i) => i.disciplineCode)
        )
        this.$set(this.form, 'allDate', [
          activeInfo.startDate,
          activeInfo.endDate
        ])
        this.$set(
          this.form,
          'joinSchoolCode',
          JSON.parse(activeInfo.joinSchoolCode)
        )
      }
      if (!this.form.orgCode) {
        this.form.orgCode = this.orgOptions[0].orgCode
      }
      if (!this.form.schoolCode) {
        this.form.schoolCode = this.schoolList[0].schoolCode
      }
      this.showPage = true
    },
    async getGradeList() {
      this.gradeOptions = await postData('/school/getGradeList', {
        schoolCode: this.userInfo?.schoolCode
      })
      return new Promise((resolve) => {
        resolve()
      })
    },
    async groupList() {

      let { records } = await postJson("/researchGroup/getResearchGroupInfoList", {
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
        pageNum: 1,
        pageSize: -1,
        isAdmin: this.isAdmin / 1,
      })
      this.groupOptions = records
      return new Promise((resolve) => {
        resolve()
      })
    },
    async getDiscipline() {
      this.disciplineOptions = await postData(
        '/discipline/getDisciplinelList',
        {
          schoolCode: this.userInfo?.schoolCode
        }
      )
      return new Promise((resolve) => {
        resolve()
      })
    },
    //添加指定教师
    addOtherUser() {
      this.showJoinPop = true
    },
    //取消指定教师
    cancelOtherUser() {
      this.form.joinUsers = []
    },
    //关闭添加弹框
    closeJoinPop() {
      this.showJoinPop = false
    },
    //添加参与教师
    joinUserChange(users) {
      users.forEach((i) => {
        if (
          !this.form.joinUsers.map((item) => item.userId).includes(i.userId)
        ) {
          this.form.joinUsers.push(i)
        }
      })
    },
    //移除参与教师
    tagJoinRemove(userId) {
      this.form.joinUsers = this.form.joinUsers.filter(
        (i) => i.userId != userId
      )
    },
    //添加主讲框
    addSpeakUser() {
      this.showSpeakPop = true
    },
    //关闭添加主讲人弹框
    closeSpeakPop() {
      this.showSpeakPop = false
    },
    //添加主讲教师
    speakUserChange(users) {
      users.forEach((i) => {
        if (
          !this.form.speakUsers.map((item) => item.userId).includes(i.userId)
        ) {
          this.form.speakUsers.push(i)
        }
      })
    },
    //移除主讲人
    tagSpeakRemove(userId) {
      this.form.speakUsers = this.form.speakUsers.filter(
        (i) => i.userId != userId
      )
    },
    async submitForm(isNolink) {
      try {
        this.btnLoading = true
        await this.$refs.step1form.validate()
        this.form.groupCode = JSON.stringify(this.form.groupCode)
        this.form.joinSchoolCode = JSON.stringify(this.form.joinSchoolCode)
        this.form.operatorId = this.userInfo.userId
        if (!this.form.classify3) {
          this.form.classify3 = -1
        }
        let { actCode } = await postJson(
          '/training/saveOrUpdateActiveInfo',
          this.form
        )
        this.btnLoading = false
        sessionStorage.setItem('actCode', actCode)
        if (isNolink) {
          this.$emit('submit')
        } else {
          this.$emit('changTab', 'link')
          this.$emit('changIsChangeTab', true)
        }
      } catch (err) {
        this.btnLoading = false
      }
    },
    resetForm() {
      this.$refs.step1form.resetFields()
    },
    //其他校区主讲人，筛选空值
    changeKnowledge(arr) {
      if (arr.length > 0) {
        if (arr[arr.length - 1].replace(/^\s*|\s*$/g, '').length === 0) {
          this.form.otherSchoolUsers.pop()
        }
      }
    }
  },
  watch: {
    'form.allDate': {
      handler(val, oldVal) {
        if (val.length > 0) {
          this.form.startDate = val[0]
          this.form.endDate = val[1]
        }
      }
    },
    'form.disciplineCodeList': {
      handler(val, oldVal) {
        let temDisciplineCode = []
        this.disciplineOptions.forEach((i) => {
          if (val.includes(i.disciplineCode)) {
            temDisciplineCode.push({
              disciplineCode: i.disciplineCode,
              disciplineName: i.disciplineName
            })
          }
        })
        this.$set(this.form, 'disciplineCode', temDisciplineCode)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.setp-form {
  padding-top: 15px;
  padding-bottom: 30px;
  width: 800px;
  margin: 0 auto;
}

.sub-form {
  margin-top: 30px;
  margin-left: 200px;
}

.scorll-list {
  padding: 2px;
  border: 1px solid rgb(231, 227, 227);
  border-radius: 5px;
  min-height: 30px;
  max-height: 128px;
  overflow: auto;

  .el-tag {
    margin: 3.5px;
    padding: 0px 5px;
  }
}
</style>
